import capitalMarketsHttp from '~/services/capital-markets/capital-markets.http';

export interface BackingResponse {
  not_found?: number[];
  total_processed: number;
  total_sent: number;
}

export interface SendBackingBulkRequest {
  ids: number[];
  intermediator: string;
}

export interface SendBackingIndividualRequest {
  backing_id: number;
  intermediator: string;
}

class BackingService {
  private readonly endpoint = '/backings/resend';

  async sendBulk(data: SendBackingBulkRequest): Promise<BackingResponse> {
    const response = await capitalMarketsHttp.post<BackingResponse>(this.endpoint, {
      ids: data.ids,
      intermediator: data.intermediator,
    });
    return response.data;
  }

  async sendIndividual(data: SendBackingIndividualRequest): Promise<BackingResponse> {
    const response = await capitalMarketsHttp.post<BackingResponse>(this.endpoint, {
      ids: [data.backing_id],
      intermediator: data.intermediator,
    });
    return response.data;
  }
}

const backingService = new BackingService();

export default backingService;
